import {
    REQUEST_VIDEOMANUALS,
    RECEIVE_VIDEOMANUALS,
    RELOAD_VIDEOMANUALS,
    ERROR_VIDEOMANUALS
} from '../types'
import {initialFetchState} from '../../constants/defaultValues'

export default (state = initialFetchState, action = {}) => {
    switch(action.type) {
        case REQUEST_VIDEOMANUALS:
            return {
                ...state,
                isFetching: true,
                message: '',
                errors: {}
            }
        case RECEIVE_VIDEOMANUALS:
            return {
                ...state,
                isFetching: false,
                data: action.payload,
                shouldReload: false,
                errors: {},
                message: '',
            }
        case RELOAD_VIDEOMANUALS:
            return {
                ...state,
                shouldReload: true
            }
        case ERROR_VIDEOMANUALS:
            return {
                ...state,
                isFetching: false,
                errors: action.errors,
                message: action.errors.server || '',
            }
        default:
            return state
    }
}